module.exports = __webpack_public_path__ + "static/media/flora.bf6a14a1.png";